import StudentBackgroundInfo from "./src/main";

/* istanbul ignore next */
StudentBackgroundInfo.install = function (Vue) {
  Vue.component(StudentBackgroundInfo.name, StudentBackgroundInfo);
};

export default StudentBackgroundInfo;
